import { Helmet } from 'react-helmet';
//import logo from './logo.svg';
//import './App.css';
import MainPage from './pages/main.page';
function App() {
  return (
    <div className={`full-app-container`}>
      <Helmet>
        <title>Equilátero +METRO</title>
        <meta name="description" content="Meta descripcion del CarStudio MG" />
      </Helmet>
      <MainPage/>
    </div>
  );
}

export default App;
